import './styles/app.scss';
import '@assets/styles/components/_preview.scss';
import DisplayManager from '@scripttag/widgets/managers/DisplayManager';
import {bindCartEvent, checkAndSaveCart} from '@scripttag/service/triggerService';
import {getChatSessionId} from '@scripttag/helpers/sessionHelpers';
import initDebugCollector from '@scripttag/helpers/debugCollector';

window.avadaFaqTrigger = () => document.getElementById('Avada-FAQ_WidgetTrigger').click();

(() => {
  const app = window.AVADA_APP_FAQS_STATUS;
  if (app && (!app.shopId || app.enableChatbox === false)) return;
  new DisplayManager().initialize();
  const sessionId = getChatSessionId();
  if (window.self !== window.top) return;
  bindCartEvent();
  initDebugCollector();
  setTimeout(() => checkAndSaveCart(sessionId), 2000);
})();
